


































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ParticaColumnContainer from "@/Ui-Components/Common/Container/ParticaColumnContainer.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import { ContentStreamDTO, IssueModel, ContentStreamDTOStatus, ListItemDTO, ContentStreamIssueDTO, PubIssueDTO, ContentStreamBillingConfigurationClient, ContentStreamBillingConfigurationDTO, ContentStreamSubscriberDTO } from "../../Generated/ParticaAPI";
import { IContentStreamService } from "../../BusinessServices/contentstream";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import ParticaStreamBase from "../Base/ParticaStreamBase.vue";
import { ParticaEvent, eParticaAction, getActionName } from "../../Models/ParticaEvent";
import { ButtonConfig, ButtonType, ButtonStatus } from "../../Models/Buttons";
import IssuesList from "@/Ui-Components/Title/IssueList/IssueList.vue";
import ContentStreamIssueForm from "@/Ui-Components/ContentStream/ContentStreamIssueForm.vue";
import ParticaDialogCard from "@/Ui-Components/Common/Container/ParticaDialogCard.vue";
import { IContentStreamIssueService } from "../../BusinessServices/contentstreamissue";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import ContentStreamForm from "@/Ui-Components/ContentStream/ContentStreamForm.vue";
import { IPublicationService } from "../../BusinessServices/publication";
import { ParticaListContent, ParticaListLineContent } from "../../Models/ParticaListModel";
import ContentStreamCreate from "@/Ui-Components/ContentStream/ContentStreamCreate.vue";
import ParticaRightDrawer from "@/Ui-Components/Common/Container/ParticaRightDrawer.vue";
import ContentStreamSubs from "./ContentStreamSubs.vue";

@Component({
	name: "ContentStreamHome",
	components: {
		ParticaColumnContainer,
		ParticaCard,
		ParticaView,
		IssuesList,
		ContentStreamIssueForm,
		ParticaDialogCard,
		ButtonList,
		ContentStreamForm,
		ContentStreamCreate,
		ParticaRightDrawer,
		ContentStreamSubs
	}
})
export default class ContentStreamHome extends ParticaStreamBase {
	@Prop() private id: number;
	private stream: ContentStreamDTO = new ContentStreamDTO();
	private contentStreamService: IContentStreamService;
	private issues: IssueModel[] = [];
	private newIssue = new ContentStreamIssueDTO();
	private newissuedialog: boolean = false;
	private contentStreamIssueService: IContentStreamIssueService;
	private showcsdialog: boolean = false;
	private streamstatus: any;
	private showstreamsetup: boolean = false;
	private subsdrawer: boolean = false;

	private issueactions: ButtonConfig[] = [
		// init our menu for the list.
		{ action: eParticaAction.ISSUE_SELECT, label: "Manage" } as ButtonConfig,
	];

	private csbuttons: ButtonConfig[] = [
		{
			label: "Save Content Stream",
			action: eParticaAction.CONTENT_STREAM_SAVE,
			type: ButtonType.OK,
			status: ButtonStatus.Enabled

		} as ButtonConfig,
		{
			label: "Cancel",
			action: eParticaAction.CONTENT_STREAM_SAVE_CANCEL,
			type: ButtonType.Cancel,
			status: ButtonStatus.Enabled
		} as ButtonConfig
	];

	private streamsetupbuttons: ButtonConfig[] = [
		{
			label: "Level Pricing",
			action: eParticaAction.CONTENT_STREAM_LEVELS,
			type: ButtonType.Normal,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
		{
			label: "Stream Setup",
			action: eParticaAction.CONTENT_STREAM_SETUP,
			type: ButtonType.Normal,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
		{
			label: "Make active",
			action: eParticaAction.CONTENT_STREAM_ACTIVE,
			type: ButtonType.Highlight,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
	];

	private streambuttons: ButtonConfig[] = [
		{
			label: "Subscribers",
			action: eParticaAction.CONTENT_STREAM_VIEW_SUBSCRIPTIONS,
			type: ButtonType.Normal,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
		{
			label: "Todo",
			action: eParticaAction.CONTENT_STREAM_TODO,
			type: ButtonType.Normal,
			status: ButtonStatus.Enabled
		} as ButtonConfig
	];

	private issuebuttons: ButtonConfig[] = [
		{
			label: "Add Issue",
			action: eParticaAction.ISSUE_ADD,
			type: ButtonType.OK,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
		{
			label: "Cancel",
			action: eParticaAction.ISSUE_CANCEL_SAVE,
			type: ButtonType.Cancel,
			status: ButtonStatus.Enabled
		} as ButtonConfig
	];

	private issuesbuttons: ButtonConfig[] = [
		{
			label: "Add Issue",
			action: eParticaAction.SHOW_ISSUE_ADD,
			type: ButtonType.OK,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
	];

	private getIssueListData(): ParticaListContent {
		const listdata: ParticaListContent = new ParticaListContent();
		this.issues.forEach(issue => {
			const line: ParticaListLineContent = new ParticaListLineContent();
			line.id = (issue.id as number).toString();
			line.title = issue.name as string;
			line.subtitle = `Created : ${(issue.issueDate as Date).toDateString()}<br>`;
			if (issue.status as number === 1) {
				line.subtitle += `<span style="color:green">Finalized</span>`;
			} else {
				line.subtitle += `<span style="color:orange">In Progress</span>`;
			}
			listdata.lines.push(line);
		});
		return listdata;
	}

	private isStreamActive() {
		return this.stream.status === ContentStreamDTOStatus.Active;
	}

	private getSubscriptionLink() {
		return `${this.stateconfig.store}/contentstream/${this.stream.guid}`;
	}

	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}

	private async init() {
		try {
			this.LoadingStart();
			this.stream = await this.contentStreamService.getContentStream(this.id);
			if (this.stream !== undefined) {
				this.streamstatus = this.stream.status;
				if (this.stream.publication !== undefined && this.stream.publication.issues !== undefined) {
					this.issues = this.stream.publication.issues.filter(i => i.status as number >= 0);
					// @ts-ignore
					this.issues = this.issues.sort((a: IssueModel, b: IssueModel) => b.id as number - a.id as number);
				}
			}
			let status: ButtonStatus = ButtonStatus.Enabled;
			if (this.stream.contentStreamBillingConfigurations === undefined || this.stream.contentStreamBillingConfigurations.length === 0) {
				this.ShowSnackbar("Setup the billing configuration to continue.");
				this.stream.contentStreamBillingConfigurations = [];
				const billing: ContentStreamBillingConfigurationDTO = new ContentStreamBillingConfigurationDTO();
				billing.contentStreamId = this.id;
				this.stream.contentStreamBillingConfigurations.push(billing);
				status = ButtonStatus.Disabled;
			}
			if (this.stream.contentStreamBillingConfigurations.length > 1) {
				this.ShowSnackbar("Invalid configuration. There is more that 1 configuration for this stream.");
				return;
			}
			this.SetButtonStatus(this.streamsetupbuttons, eParticaAction.CONTENT_STREAM_LEVELS, status);
			this.SetButtonStatus(this.streambuttons, eParticaAction.CONTENT_STREAM_TODO, status);
			this.SetButtonStatus(this.streambuttons, eParticaAction.CONTENT_STREAM_VIEW_SUBSCRIPTIONS, status);
			this.SetButtonStatus(this.issuesbuttons, eParticaAction.SHOW_ISSUE_ADD, status);

			if (this.streamstatus === ContentStreamDTOStatus.Active) {
				this.SetButtonStatus(this.streamsetupbuttons, eParticaAction.CONTENT_STREAM_ACTIVE, ButtonStatus.Disabled);
			} else {
				this.SetButtonStatus(this.streamsetupbuttons, eParticaAction.CONTENT_STREAM_ACTIVE, ButtonStatus.Enabled);
			}
			this.newIssue.contentStreamId = this.id;
			const publicationService: IPublicationService = this.particaServices.getPublicationService();

			await this.getStreamNav(this.id);
		} catch (e) {
			this.ShowErrorDialog(
				e,
				`An error occured loading the content stream ${this.id}`
			);
		} finally {
			this.LoadingEnd();
		}
	}

	private async mounted() {
		this.metadata.name = "Home";
		this.contentStreamService = this.particaServices.getContentStreamService();
		this.contentStreamIssueService = this.particaServices.getContentStreamIssueService();
		await this.init();

	}

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.CONTENT_STREAM_ACTIVE: {
					const tmp: ContentStreamDTO = await this.contentStreamService.getContentStream(this.id);
					tmp.status = ContentStreamDTOStatus.Active;
					await this.contentStreamService.saveContentStream(tmp);
					this.ShowSnackbar("The stream is now active.");
					await this.init();
					break;
				}
				case eParticaAction.SHOW_ISSUE_ADD: {
					this.newissuedialog = true;
					break;
				}
				case eParticaAction.CONTENT_STREAM_LEVELS: {
					this.navigate("contentstreamlevels", { id: `${this.id}` });
					break;
				}
				case eParticaAction.CONTENT_STREAM_BILLING_CONFIG: {
					this.navigate("contentstreambillingconfiguration", { id: `${this.id}` });
					break;
				}
				case eParticaAction.CONTENT_STREAM_SETUP: {
					this.showstreamsetup = true;
					break;
				}
				case eParticaAction.CONTENT_STREAM_EDIT: {
					this.showcsdialog = true;
					break;
				}
				case eParticaAction.CONTENT_STREAM_TODO: {
					this.navigate("contentstreamtodo", { contentStreamId: `${this.id}` });
					break;
				}
				case eParticaAction.CONTENT_STREAM_VIEW_SUBSCRIPTIONS: {
					this.subsdrawer = true;
					break;
				}
				case eParticaAction.ISSUE_SELECT: {
					this.$router.push({
						name: "contentstreamissue",
						params: { issueid: event.item.id, id: this.id.toString() }
					});
					break;
				}
				case eParticaAction.CONTENT_STREAM_FINALIZE_ISSUE: {
					this.$router.push({
						name: "contentstreamfinalise",
						params: { levelid: event.item.id, id: this.id.toString() }
					});
					break;
				}
				case eParticaAction.ISSUE_DELETE: {
					throw new Error("Not implemented");
				}
				case eParticaAction.ISSUE_ADD: {
					const newIssue: ContentStreamIssueDTO = await this.contentStreamIssueService.saveContentStreamIssue(event.item);
					this.ShowSnackbar(`New issue '${newIssue.name}' created.`);
					await this.init();
					this.newIssue = new ContentStreamIssueDTO();
					this.newIssue.id = 0;
					this.newIssue.contentStreamId = this.id;
					this.newissuedialog = false;
					break;
				}
				case eParticaAction.ISSUE_CANCEL_SAVE: {
					this.newIssue = new ContentStreamIssueDTO();
					this.newIssue.id = 0;
					this.newIssue.contentStreamId = this.id;
					this.newissuedialog = false;
					break;
				}
				case eParticaAction.CONTENT_STREAM_SAVE_CANCEL: {
					this.showcsdialog = false;
					break;
				}
				case eParticaAction.CONTENT_STREAM_SAVE_CONFIRM: {
					this.stream = await this.contentStreamService.saveContentStream(
						this.stream
					);
					this.showcsdialog = false;
					this.dialog.show = false;
					this.showstreamsetup = false;
					this.init();
					this.ShowSnackbar("Your content stream has been updated.");
					break;
				}
				case eParticaAction.CONTENT_STREAM_SAVE: {
					// check if status has changed and display confirm message.
					this.dialog.action = eParticaAction.CONTENT_STREAM_SAVE_CONFIRM;
					if (this.stream.status === ContentStreamDTOStatus.Active && this.stream.status !== this.streamstatus) {
						this.dialog.message2 = "Making the stream Active will lock the pricing / billing configuration.";
						this.dialog.show = true;
					} else if (this.stream.status === ContentStreamDTOStatus.Inactive && this.stream.status !== this.streamstatus) {
						this.dialog.message2 = "Making the stream Inactive will stop anyone being able to subscribe.";
						this.dialog.show = true;
					} else { // name or desc update
						this.dialog.message2 = "Confirm updating stream details.";
						this.dialog.show = true;
					}
					break;
				}

				default: {
					this.baseEventHandler(event);
				}
			}
		} catch (e) {
			this.ShowErrorDialog(
				e,
				`An error occured handling event ${event.action}`
			);
		} finally {
			this.LoadingEnd();
		}
	}


}
